import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { SEO } from '@/components/SEO';

export function NotFound() {
  return (
    <>
      <SEO title="Seite nicht gefunden" description="Die gesuchte Seite existiert nicht." />
      <section className="relative mt-[70px] pt-32 pb-20 text-center overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full bg-crimson/[0.04] blur-3xl pointer-events-none" />
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="relative z-10 max-w-lg mx-auto px-6">
          <span className="font-display text-8xl md:text-9xl font-bold italic text-gold/20">404</span>
          <h1 className="font-display text-3xl md:text-4xl font-bold italic text-glow mb-4 mt-4">
            Seite nicht <span className="text-gold">gefunden</span>
          </h1>
          <p className="text-text-secondary mb-8">
            Die Seite, die du suchst, existiert nicht oder wurde verschoben.
          </p>
          <Link to="/" className="inline-flex items-center gap-2 px-7 py-3 bg-gold text-surface-primary font-semibold rounded-xl shadow-gold hover:shadow-gold-lg hover:-translate-y-0.5 transition-all">
            Zurück zur Startseite
          </Link>
        </motion.div>
      </section>
    </>
  );
}